import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import { apiClient } from "../api/client";
import { EmployeePosition } from "../api/PartnerPortalGatewayApi";
import { RootState } from "../store";

interface UseEducatorsReturn {
  data: EmployeePosition[] | undefined;
  isLoading: boolean;
  error: Error | null;
  refetch: () => void;
}

export const useEducators = (): UseEducatorsReturn => {
  const selectedService = useSelector((state: RootState) => state.service.selectedService);

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["educators", selectedService?.serviceId],
    queryFn: async () => {
      if (!selectedService?.serviceId) {
        throw new Error("No service selected");
      }
      return await apiClient.educators.getServiceEmployeesForCurrentWeek(selectedService.serviceId!);
    },
    enabled: !!selectedService?.serviceId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });

  return {
    data,
    isLoading,
    error,
    refetch,
  };
};
